var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('HeroSection'),_vm._v(" "),_c('NovaLaunchSection'),_vm._v(" "),_c('PainPointsSection'),_vm._v(" "),_c('IndustrySection'),_vm._v(" "),_c('DualProductSection'),_vm._v(" "),_c('FeatureSection'),_vm._v(" "),_c('MobileSection'),_vm._v(" "),_c('CaseSection'),_vm._v(" "),_c('StatsSection'),_vm._v(" "),_c('FaqSection'),_vm._v(" "),_c('BottomCtaSection')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-ef7cd174","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/site/views/HomeView.vue
// module id = null
// module chunks = 